import { render, staticRenderFns } from "./PriceSelect.vue?vue&type=template&id=936918da&scoped=true&"
import script from "./PriceSelect.vue?vue&type=script&lang=js&"
export * from "./PriceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936918da",
  null
  
)

export default component.exports